module.exports = __webpack_public_path__ + "static/media/sdesk_screenshot_withframe_ios.b6b7acaf.png";